import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from '../../services/apiUrls';
import { updateDisplayBookInReducer, getChannelMenuCategories, getAllDisplayBooks, saveDisplayBookData, saveChannelMenuCategories, updateChannelMenu, createOrUpdateDisplayBook, deleteDisplayBook } from '../slices';

async function commonPostData(url: string, data: any) {
  try {
    const postApi = api.request({
      method: 'POST',
      url: url,
      data
    });
    const fetchResponse = await postApi;
    return fetchResponse;

  } catch (e) {
  }
}
export interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string
  code?: any;
}

const validateDescription = (item: any) => {
  if (item.baseDescription && item.baseDescription === item.description) {
    delete item.description;
  }

  if (item.baseDescription?.length >= 0) {
    delete item.baseDescription
  }
}

const getApiDataToPost = (payloadData: any) => {
  payloadData.displayItems.forEach((cateogryItem: any) => {
    cateogryItem?.items?.forEach((item: any) => {
      validateDescription(item)
    })

    cateogryItem?.subCategories?.forEach((subCategoriesItem: any) => {
      subCategoriesItem?.items?.forEach((item: any) => {
        validateDescription(item)
      })
    })
  })

  return {
    displayBookId: payloadData.displayBookId,
    displayItems: payloadData.displayItems
  }
}

function* fetchAllCategories(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CHANNEL_MENU.getCategoriesApi + actions.payload
    })
    yield put(saveChannelMenuCategories(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchAllDisplayBooks() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CHANNEL_MENU.getDisplayBookApi
    })
    yield put(saveDisplayBookData(response))
  } catch (error) {
    console.log(error);
  }
}

function* updateDisplayBook(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CHANNEL_MENU.saveDisplayBookApi,
      data: actions.payload.dataToPost
    })
    if (response && !response?.code) {
      actions.payload?.callback && actions.payload.callback(response);
      yield put(getAllDisplayBooks());
      updateDisplayBookInReducer(actions.payload);
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteDisplayBookData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.CHANNEL_MENU.deleteDisplayBookApi(actions.payload?.displayBookId),
    })
    if (!response?.code) {
      actions.payload?.callback && actions.payload.callback(response);
    }
  } catch (error) {
    console.log(error);
  }
}

function* updateChannelMenuData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CHANNEL_MENU.saveChannelMenuApi(actions.payload.dataToPost?.displayBookId),
      data: getApiDataToPost(actions.payload.dataToPost)
    })
    if (response && !response?.code) {
      actions.payload?.callback && actions.payload.callback(response);
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getChannelMenuCategories.type, fetchAllCategories);
  yield takeEvery(getAllDisplayBooks.type, fetchAllDisplayBooks);
  yield takeEvery(createOrUpdateDisplayBook.type, updateDisplayBook);
  yield takeEvery(updateChannelMenu.type, updateChannelMenuData);
  yield takeEvery(deleteDisplayBook.type, deleteDisplayBookData);
}